import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { reduxForm } from 'redux-form'
import shortid from 'shortid'
import {CopyToClipboard} from 'react-copy-to-clipboard'

import './ToolLeftMenu.css'

import { 
  setTrayOpen, 
  pmUpdateFromHybrid, 
  showTooltip, 
  hideTooltip 
} from '../../actions/actions.export.js'

import CustomField from '../CustomField/CustomField.js'
import Button from '../Button/Button.js'
import Tabs from '../Tabs/Tabs.js'
import Tags from '../Tags/Tags.js'

import canI from '../../canI.js';

class ToolLeftMenu extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      copied: false,
      adRandomizer: 0
    }
  }

  componentDidMount(){
    this.setState({
      adRandomizer: Math.random()
    })
  }

  render(){
    const {user, team, dispatch, globalReducer, patternManager, cacheID} = this.props;

    var pat = patternManager.cache[cacheID];
    var data = {
      text: pat.text
    };
    if(pat.calculator){
      data.fromCalculator = pat.calculator.name;
      data.fieldValues = {};
      for(var i in pat.calculator.fieldObject){
        data.fieldValues[i] = pat.calculator.fieldObject[i];
      }
    }

    var theme = undefined;
    let isFirm = false;
    let isEnterprise = false;
    if(team.current && team.cache[team.current]){
      theme = team.cache[team.current].theme;
      isFirm = team.cache[team.current].isFirm;
      isEnterprise = team.cache[team.current].isEnterprise;
    }

    var shareURL = window.location.origin + '/pat/#' + encodeURIComponent(window.btoa(JSON.stringify(data)));

    return <div id="tool-left-menu" style={{
        background: (globalReducer.lights && theme) ? theme : undefined
      }}>

      <form className="tool-left-menu-group">
        
        <Link to="/" className="tool-block-fill button-link no-underline">
          <div className="brand-font" style={{
            color: (!globalReducer.lights && theme) ? theme : undefined
          }}>
            <span className="brand-space-fix">P</span>attycake
            <div className="brand-super-script">
              {
                team.current ? (
                isEnterprise ? "ENTERPRISE"
                :
                isFirm ? "FOR FIRMS" 
                : 
                "FOR TEAMS"
                )
                :
                user.roles.pro && "PRO"
              }
              
            </div>
          </div>

        </Link>
        
        <div className="tool-left-menu-margin-bottom tool-left-menu-group-item tool-left-menu-name-input">
          <CustomField
            type="text"
            name="name"
            placeholder="untitled pattern"
            inline={true}
            value={this.state.name}
            maxLength={31}
            hardLimit={true}
            minRows={1}
            timeout={2000}
            multipleRows={true}
            onBlur={(e) => { dispatch(pmUpdateFromHybrid({cacheID: cacheID, pattern: {name: e }, regenText: true})) }}
            onChange={(e) => { dispatch(pmUpdateFromHybrid({cacheID: cacheID, pattern: {name: e }, regenText: true})) }}
          />
        </div>

        <div className="tool-left-menu-group-item tool-left-menu-margin-bottom">
          <CustomField
            type="text"
            name="description"
            placeholder="what is this pattern for?"
            inline={true}
            minRows={3}
            maxLength={140}
            hardLimit={true}
            multipleRows={true}
            timeout={2000}
            value={this.state.description}
            onChange={(e) => { dispatch(pmUpdateFromHybrid({cacheID: cacheID, pattern: {description: e }, regenText: true})) }}
            onBlur={(e) => { dispatch(pmUpdateFromHybrid({cacheID: cacheID, pattern: {description: e }, regenText: true})) }}
          />
        </div>
        
        <div className="tool-left-menu-margin-bottom tool-left-menu-group-item flex-center-column">
          <Tabs
            items={[
                {
                  display: "Revit",
                  value: 'REVIT'
                },
                {
                  display: "AutoCAD",
                  value: 'AUTOCAD'
                }
              ]}
            value={patternManager.cache[cacheID].format}
            size='medium'
            onChange={(e) => { dispatch(pmUpdateFromHybrid({cacheID: cacheID, pattern: {format: e.value }, regenText: true})) }}
            />
        </div>

        <div className={"tool-left-menu-group-revit-only " + (patternManager.cache[cacheID].format === 'AUTOCAD' ? "tool-left-menu-group-revit-only-hide":"")}>
          <div className="tool-left-menu-margin-bottom tool-left-menu-group-item flex-center-column">
            <Tabs
              items={[
                  {
                    display: "Inches",
                    value: 'INCH'
                  },
                  {
                    display: "Millimeters",
                    value: 'MM'
                  }
                ]}
              value={patternManager.cache[cacheID].units}
              size='medium'
              disabled={patternManager.cache[cacheID].format === 'AUTOCAD'}
              onChange={(e) => { dispatch(pmUpdateFromHybrid({cacheID: cacheID, pattern: {units: e.value }, regenText: true})) }}
              />
          </div>
          
          <div className="tool-left-menu-margin-bottom tool-left-menu-group-item flex-center-column">
            <Tabs
              items={[
                  {
                    display: "Drafting",
                    value: 'DRAFTING'
                  },
                  {
                    display: "Model",
                    value: 'MODEL'
                  }
                ]}
              value={patternManager.cache[cacheID].type}
              size='medium'
              disabled={patternManager.cache[cacheID].format === 'AUTOCAD'}
              onChange={(e) => { dispatch(pmUpdateFromHybrid({cacheID: cacheID, pattern: {type: e.value }, regenText: true})) }}
              />
          </div>
        </div>
        
        {
          canI(user, team, 'save_private_patterns', team.current) && <div className="tool-left-menu-margin-bottom tool-left-menu-group-item flex-center-column">
            <Tabs
              items={[
                  {
                    display: <span>Public</span>,
                    value: false
                  },
                  {
                    display: <span>Private</span>,
                    value: true
                  }
                ]}
              value={patternManager.cache[cacheID].private}
              size='medium'
              onChange={(e) => { dispatch(pmUpdateFromHybrid({cacheID: cacheID, pattern: {private: e.value }, regenText: false})) }}
              />
          </div>
        }
        
        {
          canI(user, team, 'tags', team.current) && <div className="tool-left-menu-margin-bottom tool-left-menu-group-item tool-left-menu-group-item-left">
            <Tags 
              value={patternManager.cache[cacheID].tags}
              suggestions={patternManager.tagList} 
              onChange={(e) => { dispatch(pmUpdateFromHybrid({cacheID: cacheID, pattern: {tags: e }, regenText: false})) }}
              placeholder="Add a tag..."
              />
          </div>
        }

        { canI(user, team, 'projects', team.current) && <hr/> }    
        {
          canI(user, team, 'projects', team.current) && <div className="tool-left-menu-margin-bottom tool-left-menu-group-item-left">
            <Tags 
              value={patternManager.cache[cacheID].projects} 
              suggestions={patternManager.projectList}
              onChange={(e) => { dispatch(pmUpdateFromHybrid({cacheID: cacheID, pattern: {projects: e }, regenText: false})) }}
              placeholder="Assign to projects..."
              />
          </div>
        }        
      </form>

      <div className="tool-left-menu-group">
        <div>

          <div 
            className={"rotate-wrapper tool-block-fill tool-block-fill-btn " + (globalReducer.trayOpen.calculators ? "tool-block-selected" : "")}
            onClick={(e)=>{ dispatch(setTrayOpen({
                tray: 'calculators',
                open: !globalReducer.trayOpen.calculators
              }))}
            }>
            <span><i className="fas fa-calculator fa-lg fa-fw"/>&nbsp;&nbsp;Pattern Templates</span>
            <span key={shortid.generate()} className="translucent"><i className={globalReducer.trayOpen.calculators ? "far fa-lg fa-fw fa-angle-left" : "far fa-lg fa-fw fa-angle-right"}/></span>
          </div>

          <div 
            className={"rotate-wrapper tool-block-fill tool-block-fill-btn " + (globalReducer.trayOpen.library ? "tool-block-selected" : "")}
            onClick={(e)=>{ dispatch(setTrayOpen({
                tray: 'library',
                open: !globalReducer.trayOpen.library
              }))}
            }>
            <span><i className="fad fa-books fa-lg fa-fw"/>&nbsp;&nbsp;Pattycake Library</span>
            <span key={shortid.generate()} className="translucent"><i className={globalReducer.trayOpen.library ? "far fa-lg fa-fw fa-angle-left" : "far fa-lg fa-fw fa-angle-right"}/></span>
          </div>
          

          {
            (user.isLoggedIn && !(team.current && team.cache[team.current])) && 
              <div 
                className={"tool-block-fill rotate-wrapper tool-block-fill-btn " + (globalReducer.trayOpen.saved ? "tool-block-selected" : "")}
                onClick={(e)=>{ dispatch(setTrayOpen({
                    tray: 'saved',
                    open: !globalReducer.trayOpen.saved
                  }))}
                }>
                <span><i className="fas fa-folder-open fa-lg fa-fw"/>&nbsp;&nbsp;My Patterns</span>
                <span key={shortid.generate()} className="translucent "><i className={globalReducer.trayOpen.saved ? "far fa-lg fa-fw fa-angle-left" : "far fa-lg fa-fw fa-angle-right"}/></span>
              </div>
          }
          {
            (user.isLoggedIn && team.current && team.cache[team.current]) && 
              <div 
                className={"tool-block-fill rotate-wrapper tool-block-fill-btn " + (globalReducer.trayOpen.saved ? "tool-block-selected" : "")}
                onClick={(e)=>{ dispatch(setTrayOpen({
                    tray: 'saved',
                    open: !globalReducer.trayOpen.saved
                  }))}
                }>
                <span className="text-ellipsis"><i className="fas fa-folder-open fa-lg fa-fw"/>&nbsp;&nbsp;{team.cache[team.current].isFirm ? "Firm" : (team.cache[team.current].isEnterprise ? team.cache[team.current].display_name : "Team")} Patterns</span>
                <span key={shortid.generate()} className="translucent "><i className={globalReducer.trayOpen.saved ? "far fa-lg fa-fw fa-angle-left" : "far fa-lg fa-fw fa-angle-right"}/></span>
              </div>
          }
        </div>
        {
          !canI(user, team, 'ad_free', team.current) && 
          <div className="tool-left-menu-ad">
            {
              this.state.adRandomizer > .5 ?
              <a href="https://theschool.studio" target="_blank">
                <div className="tool-left-menu-ad-image-wrapper">
                  <img src="/img/school-objects-in-mirror.png"/>
                </div>
                <div className="tool-left-menu-ad-overlay">
                  theschool.studio <i className="far fa-external-link"/>
                </div>
              </a>
              :
              <a href="https://not.yet.digital" target="_blank">
                <div className="tool-left-menu-ad-image-wrapper">
                  <img src="/img/not-yet-digital-home.png"/>
                </div>
                <div className="tool-left-menu-ad-overlay">
                  notyetdigital.com <i className="far fa-external-link"/>
                </div>
              </a>
            }
            {/*<span>Advertise to architects and designers around the globe.</span>*/}
          </div>
        }
        <div className="tool-left-menu-group-item tool-left-menu-group-footer">
          <div className="tool-left-menu-group-item-center">
            { 
              !canI(user, team, 'ad_free', team.current) ? 
              <a href="mailto:ads@pattycake.io">ads@pattycake.io</a> 
              :
              <span>by <a href="http://theschool.studio" target="_blank" rel="noopener noreferrer">school</a> + <a href="https://not.yet.digital" target="_blank" rel="noopener noreferrer">not.yet.digital</a></span>
            }
          </div>
        </div>
      </div>
    </div>
  }
}


ToolLeftMenu = reduxForm({
  // a unique name for the form
  form: 'ToolLeftMenu',
  enableReinitialize: true,
  destroyOnUnmount: false
})(ToolLeftMenu)


ToolLeftMenu = connect((state, ownProps) => {
  const { globalReducer, patternManager, user, team } = state;

  var initialValues = {};
  if(patternManager.cache[ownProps.cacheID]){
    initialValues = {
      name: patternManager.cache[ownProps.cacheID].name || "",
      description: patternManager.cache[ownProps.cacheID].description || "",
      pattern: patternManager.cache[ownProps.cacheID],
      libraryTrayOpen: globalReducer.trayOpen.library,
      savedTrayOpen: globalReducer.trayOpen.saved,
      calculatorTrayOpen: globalReducer.trayOpen.calculators,
    };
  }

  return {
    patternManager,
    initialValues,
    user,
    team,
    globalReducer,
    state
  }
})(ToolLeftMenu);


export default ToolLeftMenu;


// WEBPACK FOOTER //
// ./src/components/ToolLeftMenu/ToolLeftMenu.js